import React from "react";
import "./App.css";
import { ImageDisplayPanel } from "./components/ImageDisplayPanel";

function App() {
  return <ImageDisplayPanel />;
}

export default App;
